import { render, staticRenderFns } from "./CreateTwitterReportDialog.vue?vue&type=template&id=0bc0ff85"
import script from "./CreateTwitterReportDialog.vue?vue&type=script&lang=ts"
export * from "./CreateTwitterReportDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports